import { render, staticRenderFns } from "./PathwayListFilters.vue?vue&type=template&id=0064793b&"
import script from "./PathwayListFilters.vue?vue&type=script&lang=js&"
export * from "./PathwayListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports